<template>
  <div class="loading flex items-center justify-center">
    <div class="overlay"></div>
    <div class="load-container">
      <div class="load-animation">
        <div class="dot dot-one"></div>
        <div class="dot dot-two"></div>
        <div class="dot dot-three"></div>
      </div>
      <div class="load-text">{{msg}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingUI',
  props: { // props passed into component
    msg: String,
    overlay: Boolean
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 16px;
  }

  .overlay {
    position: absolute;
    box-sizing: border-box;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.5);
  }

  .load-text {
    margin-top: 10px;
  }

  .load-container {
    position: relative;
    width: 100%;
    text-align: center;
    padding: 15px 0px;
  }

  .load-animation {
    width: 75px;
    height: 75px;
    padding-left: calc(50% - 35px);
  }

  .dot {
    display: block;
    position: absolute;
    border-radius: 100px;
  }

  .dot-one {
    animation: animate1-1 .7s ease-in-out infinite;
    background: rgb(41, 46, 94);
    width: 30px;
    height: 30px;
    margin-top: 10px;
    margin-left: 7px;
  }

  .dot-two {
    animation: animate1-2 .7s ease-in-out infinite;
    background: rgb(60, 184, 223);
    height: 22px;
    width: 22px;
    margin-top: 34px;
    margin-left: 31px;
  }

  .dot-three {
    animation: animate1-3 .7s ease-in-out infinite;
    background: rgb(59, 70, 172);
    height: 17px;
    width: 17px;
    margin-top: 42px;
    margin-left: 12px;
  }

  @keyframes animate1-1 {
    0% {
      transform: translate(5px,10px) scale(0.3);
    }

    30% {
      transform: translate(5px,10px)  scale(0.3);
    }

    80% {
      transform: translate(0px,0px) scale(1.0);
    }

    100% {
      transform: translate(0px,0px) scale(1.0);
    }
  }

  @keyframes animate1-2 {
    0% {
      transform: translate(-5px,0px)  scale(0.3);
    }

    15% {
      transform: translate(-5px,0px)  scale(0.3);
    }

    65% {
      transform: translate(0px,0px)  scale(1.0);
    }

    100% {
      transform: translate(0px,0px)  scale(1.0);
    }
  }

  @keyframes animate1-3 {
    0% {
      transform: translate(5px,-5px)  scale(0.3);
    }

    0% {
      transform: translate(5px,-5px)  scale(0.3);
    }

    50% {
      transform: translate(0px,0px)  scale(1.0);
    }

    100% {
      transform: translate(0px,0px)  scale(1.0);
    }
  }
</style>